import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterComponent } from './footer.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { IconModule } from '@abhinavakhil/iconify-angular';
import { ContainerModule } from '../../directives/container/container.module';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MatButtonModule, IconModule, ContainerModule],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
